import { render, staticRenderFns } from "./Connection.vue?vue&type=template&id=a8f6d758&scoped=true&"
import script from "./Connection.vue?vue&type=script&lang=js&"
export * from "./Connection.vue?vue&type=script&lang=js&"
import style0 from "./Connection.vue?vue&type=style&index=0&id=a8f6d758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f6d758",
  null
  
)

export default component.exports